export default "__VITE_ASSET___j6dBtBk__"